import { PAGE_FORM, PAGE_ERROR, PAGE_DEBUG, PAGE_SUCCESS } from '../routes';
import { usePayloadStore } from '../stores/payload-store';
import { useApplicationStore } from '../stores/application-store';
import { useOriginStore } from '../stores/origin-store';

export default async function processPayload({ to, router }) {
    const payload = usePayloadStore();
    const originStore = useOriginStore();
    if (to.query.uuid && to.query.payload) {
        await payload.decryptPayload({
            uuid: to.query.uuid,
            payload: to.query.payload,
        });

        originStore.origin = to.query.origin;

        // Catching empty error because of
        // https://github.com/vuejs/vue-router/issues/2872#issuecomment-519073998.
        return router.replace({
            name: PAGE_FORM,
        }).catch(() => {});
    }

    const application = useApplicationStore();
    if (application.uuid) return { name: PAGE_SUCCESS };

    if (payload.exists) return true;

    if (import.meta.env.MODE === 'development') return { name: PAGE_DEBUG };

    return {
        name: PAGE_ERROR,
    };
}
